<template>
  <div id="videoPlayer">
    <img src="../../assets/img/playicon.png" class="playIcon" @click="ToggleIsShowVideo()" />

    <div v-if="isShowVideo" class="videoPlayerBox">
      <div class="header">
        <h3>{{ $t("Video_Tutorial") }}</h3>
        <p class="textBlue cursorPointer" @click="ShowModalVideoPlayer()">{{ $t("Expand_View") }}</p>
      </div>
      <div class="videoListBox">
        <div v-for="(youtubeItem, index) in youtubeUrlList" :key="index + '-youtubeItem'" class="youtubeItem">
          <div class="youtubeName" :class="{ isShowVideo: youtubeItem.isShow }" @click="ShowVideo(index)">
            <p>{{ youtubeItem.name }}</p>
            <i v-if="youtubeItem.isShow" class="fas fa-angle-up"></i>
            <i v-else class="fas fa-angle-down"></i>
          </div>
          <div
            class="video"
            v-if="
              youtubeItem.isShow &&
                iframe &&
                (youtubeItem.isSendFeedback === videoFeedback.None ||
                  youtubeItem.isSendFeedback === videoFeedback.Complete)
            "
            v-html="iframe"
          ></div>
          <div
            v-if="youtubeItem.isShow && youtubeItem.isSendFeedback === videoFeedback.None"
            class="d-flex align-items-center justify-content-between my-3"
          >
            <p>{{ $t("Video_Feedback.Small.Header") }}</p>
            <div class="d-flex align-items-center">
              <p class="mr-4 thumsUp" @click="SendFeedback(index, videoFeedback.Yes)">
                <i class="fas fa-thumbs-up "></i>
                {{ $t("Video_Feedback.Small.Yes") }}
              </p>
              <p class="thumsDown" @click="SendFeedback(index, videoFeedback.No)">
                <i class="fas fa-thumbs-down "></i> {{ $t("Video_Feedback.Small.No") }}
              </p>
            </div>
          </div>
          <div class="mb-3" v-if="youtubeItem.isShow && youtubeItem.isSendFeedback === videoFeedback.No">
            <CheckBox
              :label="$t('Video_Feedback.Small.No_Choice.Not_Understand')"
              :checked.sync="feedbackSelectedChoice.notUnderstand"
            />
            <CheckBox
              :label="$t('Video_Feedback.Small.No_Choice.Not_Sovle_Issues')"
              :checked.sync="feedbackSelectedChoice.notSovleIssues"
            />
            <CheckBox
              :label="$t('Video_Feedback.Small.No_Choice.Video_Need_More_Info')"
              :checked.sync="feedbackSelectedChoice.videoNeedMoreInfo"
            />
            <CheckBox
              :label="$t('Video_Feedback.Small.No_Choice.Video_Too_Much_Info')"
              :checked.sync="feedbackSelectedChoice.videoTooMuchInfo"
            />
            <CheckBox
              :label="$t('Video_Feedback.Small.No_Choice.Other')"
              :checked.sync="feedbackSelectedChoice.other"
            />
            <TextArea
              width="100%"
              v-if="feedbackSelectedChoice.other"
              :label="$t('Video_Feedback.Small.Other')"
              :placeholder="$t('Video_Feedback.Small.Other_Placeholder')"
              maxlength="500"
              v-model="feedbackOtherMessage"
            />
            <div class="mt-2 d-flex justify-content-end">
              <buttonStyle
                height="32px"
                width="120px"
                styleButton="primary"
                theme="mint"
                :text="$t('Video_Feedback.Small.Submit')"
                textSize="14px"
                :disabled="feedbackOtherMessage.length > 500"
                @click="SendFeedback(index, videoFeedback.Submit)"
              />
            </div>
          </div>
          <div v-if="youtubeItem.isShow && youtubeItem.isSendFeedback === videoFeedback.Complete">
            <p class="text-center my-3">{{ $t("Video_Feedback.Small.Thank_You") }}</p>
          </div>
        </div>
      </div>
    </div>
    <i v-if="isShowVideo" class="icon-close" @click="isShowVideo = false"></i>
    <ModalVideoPlayer
      v-if="showModalVideoPlayer"
      :showModal.sync="showModalVideoPlayer"
      :youtubeUrlList="youtubeUrlList"
      :feedbackSelectedChoice.sync="feedbackSelectedChoice"
      :feedbackOtherMessage.sync="feedbackOtherMessage"
      :userFeedbackVideo.sync="userFeedbackVideo"
      @SendFeedback="SendFeedback"
      @update:feedbackOtherMessage="feedbackOtherMessage = $event"
      @SetSelectedChoiceDefault="SetSelectedChoiceDefault"
    />
  </div>
</template>

<script lang="ts">
import ModalVideoPlayer from "@/components/modal/modalVideoPlayer/ModalVideoPlayer.vue";
import { LoadingStatusType, Position, VideoFeedback } from "@/enums/enums";
import { GetYoutubeUrlFromPageName } from "@/helper/youtubeHelper";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreLogIn = namespace("LogIn");
const StoreVideofeedback = namespace("Videofeedback");

@Component({ components: { ModalVideoPlayer } })
export default class VideoPlayer extends Vue {
  isShowVideo = false;
  showModalVideoPlayer = false;
  iframe = "";
  youtubeUrlList: any = [];
  feedbackSelectedChoice: any = {
    notUnderstand: false,
    notSovleIssues: false,
    videoNeedMoreInfo: false,
    videoTooMuchInfo: false,
    other: false,
  };
  feedbackOtherMessage: any = "";
  videoFeedback = VideoFeedback;
  userFeedbackVideo = [];

  @StoreLogIn.Getter
  public getUserModel!: any;
  @StoreLogIn.Getter
  private getMerchant!: SelectedMerchantModel;
  @StoreVideofeedback.Getter
  private getUserFeedbackVideo!: any;
  @StoreVideofeedback.Getter
  private getUserFeedbackVideoLoadingStatus!: LoadingStatusType;
  @StoreVideofeedback.Action
  private DoSendVideoFeedback!: (_input: any) => Promise<boolean>;
  @StoreVideofeedback.Action
  private DoGetVideoFeedback!: (_input: any) => void;
  created() {
    this.SetVideoIframe(this.$route.name);
    this.SetSelectedChoiceDefault();
  }

  @Watch("$route")
  routeChanged(newValue: { name: any }, oldValue: any) {
    this.SetSelectedChoiceDefault();
    this.SetVideoIframe(newValue.name);
  }
  @Watch("$route.query", { immediate: true })
  routeQueryChanged() {
    const { openVideo, videoIndex } = this.$route.query;
    if (openVideo) {
      this.ToggleIsShowVideo(true);
      if (typeof videoIndex === "string") {
        this.$nextTick(() => {
          this.ShowVideo(parseInt(videoIndex));
        });
      }
    }
  }

  @Watch("showModalVideoPlayer")
  showModalVideoPlayerChanged(newValue: any) {
    if (!newValue) {
      this.isShowVideo = true;
    }
  }

  @Watch("getUserFeedbackVideoLoadingStatus")
  getUserFeedbackVideoLoadingStatusChanged(newValue: any) {
    if (newValue === LoadingStatusType.Success) {
      this.SetUserFeedbackVideo();
    }
  }

  public ToggleIsShowVideo(openVideo = false) {
    if (openVideo) {
      this.isShowVideo = !this.isShowVideo;
    } else {
      this.isShowVideo = true;
    }
    if (this.isShowVideo && this.getUserFeedbackVideoLoadingStatus == LoadingStatusType.None) {
      const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
      this.DoGetVideoFeedback(input);
    }
  }

  public SetVideoIframe(urlName: any) {
    this.youtubeUrlList = GetYoutubeUrlFromPageName(urlName);
    if (this.youtubeUrlList && this.youtubeUrlList.length > 0) {
      this.youtubeUrlList[0].isShow = true;
      this.SetIframe(this.youtubeUrlList[0].url);
      if (this.CheckIsAlreadySendFeedbackVideo(this.youtubeUrlList[0].url)) {
        this.youtubeUrlList[0].isSendFeedback = VideoFeedback.Complete;
      }
    }
  }

  public ShowVideo(youtubeIndexItem: any) {
    this.youtubeUrlList.forEach((youtube: { url: any; isShow: boolean; isSendFeedback: number }, index: any) => {
      youtube.isSendFeedback = VideoFeedback.None;
      if (index == youtubeIndexItem) {
        this.SetIframe(youtube.url);
        youtube.isShow = !youtube.isShow;
        if (this.CheckIsAlreadySendFeedbackVideo(youtube.url)) {
          youtube.isSendFeedback = VideoFeedback.Complete;
        } else {
          this.SetSelectedChoiceDefault();
        }
      } else {
        youtube.isShow = false;
      }
    });
  }

  public SendFeedback(youtubeIndexItem: any, feedbackChoice: number) {
    const currentYoutubeItem = this.youtubeUrlList[youtubeIndexItem];
    const position: any = {
      [Position.BusinessOwner]: this.$t("business_owner"),
      [Position.Bookkeeper]: this.$t("bookkeeper"),
      [Position.Admin]: this.$t("Admin"),
      [Position.Accountant]: this.$t("accountant"),
      [Position.Employee]: this.$t("Employee"),
      [Position.AccountingFirm]: this.$t("Accounting_Firm"),
      [Position.Student]: this.$t("Student"),
      [Position.Other]: this.$t("Other"),
    };
    const user = {
      userId: this.getUserModel.userId,
      userName: this.getUserModel.displayName,
      userPosition: position[this.getUserModel.position],
      userTelephone: this.getUserModel.phone,
    };
    const merchant = {
      merchantId: this.getMerchant.merchantId,
      merchantName: this.getMerchant.merchantName,
    };
    if (feedbackChoice === VideoFeedback.Yes) {
      const input = {
        ...user,
        ...merchant,
        topicName: currentYoutubeItem.name,
        url: currentYoutubeItem.url,
        feedbackUserDetail: [{ key: this.$t("Video_Feedback.Large.Yes"), value: "Checked" }],
      };
      this.DoSendVideoFeedback(input).then((res) => {
        const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
        this.DoGetVideoFeedback(input);
      });
    } else if (feedbackChoice === VideoFeedback.No) {
      currentYoutubeItem.isSendFeedback = VideoFeedback.No;
    } else if (feedbackChoice === VideoFeedback.Submit) {
      const feedbackOptions = [
        { key: "notUnderstand", textKey: "Not_Understand" },
        { key: "notSovleIssues", textKey: "Not_Sovle_Issues" },
        { key: "videoNeedMoreInfo", textKey: "Video_Need_More_Info" },
        { key: "videoTooMuchInfo", textKey: "Video_Too_Much_Info" },
        { key: "other", textKey: "Other" },
      ];

      const feedbackDetail: any = [];
      feedbackOptions.forEach((option) => {
        if (this.feedbackSelectedChoice[option.key]) {
          feedbackDetail.push({
            key: this.$t(`Video_Feedback.Small.No_Choice.${option.textKey}`),
            value: option.key === "other" ? this.feedbackOtherMessage : "Checked",
          });
        }
      });
      feedbackDetail.push({ key: this.$t("Video_Feedback.Large.No"), value: "Checked" });
      const input = {
        ...user,
        ...merchant,
        topicName: currentYoutubeItem.name,
        url: currentYoutubeItem.url,
        feedbackUserDetail: feedbackDetail,
      };
      this.DoSendVideoFeedback(input).then((res) => {
        const input = { userId: this.getUserModel.userId, merchantId: this.getMerchant.merchantId };
        this.DoGetVideoFeedback(input);
      });
    }
  }

  public SetIframe(url: any) {
    this.iframe = `<iframe width="300" height="168.73" src="${url}" title="YouTube video player" frameborder="0"  clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
  public ShowModalVideoPlayer() {
    this.isShowVideo = false;
    this.showModalVideoPlayer = true;
  }
  public SetUserFeedbackVideo() {
    this.userFeedbackVideo = [];

    if (this.getUserFeedbackVideo.length > 0) {
      this.userFeedbackVideo = this.getUserFeedbackVideo;
    }

    const youtube = this.youtubeUrlList.find((x: any) => x.isShow);
    if (youtube) {
      if (this.CheckIsAlreadySendFeedbackVideo(youtube.url)) {
        youtube.isSendFeedback = VideoFeedback.Complete;
      } else {
        this.SetSelectedChoiceDefault();
      }
    }
  }
  public SetSelectedChoiceDefault() {
    this.feedbackSelectedChoice = {
      notUnderstand: false,
      notSovleIssues: false,
      videoNeedMoreInfo: false,
      videoTooMuchInfo: false,
      other: false,
    };
    this.feedbackOtherMessage = "";
  }
  CheckIsAlreadySendFeedbackVideo(url: string) {
    return this.getUserFeedbackVideo.filter((feedback: any) => feedback.url === url).length > 0;
  }
}
</script>

<style lang="scss" scoped>
@include videoFeedback;
#videoPlayer {
  .videoPlayerBox {
    bottom: 90px;
    right: 88px;
    position: fixed;
    z-index: 999;
    background: white;
    border-radius: 10px;
    width: 340px;
    @include shadowboxLv2;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #dadbe6;
    }
    .videoListBox {
      padding: 20px;
      height: 300px;
      overflow: auto;
      .youtubeItem {
        .youtubeName {
          padding: 5px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #dadbe6;
          border-radius: 10px;
          cursor: pointer;
          margin-bottom: 8px;
        }
        .isShowVideo {
          border: 1px solid #ffffff;
          p {
            @include font("bold");
          }
        }
      }

      .video {
        width: 100%;
        height: 168.73px;
        overflow: hidden;
        @include shadowboxLv2;
        border-radius: 10px;
        margin-bottom: 8px;
      }
    }
  }

  .icon-close {
    margin-left: 5px;
    font-size: 10px;
    padding: 5px;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    transition: 0.5s;
    bottom: 430px;
    right: 61px;
    position: fixed;
    background: #dadbe6;
    z-index: 999;

    &:hover {
      color: $border_hover;
      background: $gray_default;
    }
  }

  .playIcon {
    border-radius: 50%;

    box-shadow: 0px 3px 6px rgba(103, 103, 115, 0.5);
    position: fixed;
    bottom: 88px;
    right: 20px;
    width: 48px;
    height: 48px;
    cursor: pointer;
    &:hover {
      color: $border_hover;
      background: $gray_default;
    }
    z-index: 999;
  }
}
</style>
